import React, { useState } from 'react';
import TextLoop from 'react-text-loop';
import ConsultingSearch from 'components/Common/ConsultingSearch';

const SearchBox: React.FC<{ skills: { name: string; id: number }[] }> = ({ skills }) => {
  const [activeSkill, setActiveSkill] = useState(null);
  const [searchValue, setSearchValue] = useState('');

  return (
    <div className="m-auto flex max-w-[1180px] z-10  flex-col items-end">
      <div className="w-full xl:w-[680px] relative">
        <div className="items-center md:items-start overflow-hidden flex h-fit flex-col md:flex-row text-[24px] md:text-[32px] font-bold md:pr-[24px] mb-[20px]">
          <span className=" text-white text-center">قرار ملاقات با یک مشاور</span>
          {skills && (
            <TextLoop interval={3000} springConfig={{ stiffness: 100, damping: 12 }}>
              {skills?.map((item) => (
                <span key={item.id} className="text-blue-14 mr-[8px] ">
                  {item.name}
                </span>
              ))}
            </TextLoop>
          )}
        </div>

        <ConsultingSearch
          activeSkill={activeSkill as string}
          {...{ searchValue, setSearchValue }}
        />

        <div className="xl:mx-[32px] mt-[12px] flex gap-[8px] flex-wrap justify-center">
          {skills?.map(({ name, id }) => (
            <div
              onClick={(): void => setActiveSkill(activeSkill === id ? null : id)}
              className={`${
                id === activeSkill ? 'bg-white text-other3' : 'text-white'
              } border-white border cursor-pointer rounded-full duration-300 text-[12px] md:text-[14px] py-[2px] px-[16px]`}
              key={id}
            >
              {name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchBox;
